function parseCollectionNumber(collectionPartNumber) {
  // If a single number
  if (!collectionPartNumber.match(/[+-]/)) {
    return [collectionPartNumber];
  }

  // If a non-equivalent marked single number e.g: 5-z
  if (collectionPartNumber.match(/-z/)) {
    return [collectionPartNumber];
  }

  const validCodes = [];

  const groupsToProcess = collectionPartNumber.split("+");

  groupsToProcess.forEach((group) => {
    insertValidCodes(validCodes, group);
  });

  return validCodes;
}

// Parses and inserts the valid codes into a given array
function insertValidCodes(validCodesArray, groupToProcess) {
  if (!groupToProcess.includes("-")) {
    validCodesArray.push(groupToProcess);
    return;
  }

  // If it is a range, get low high tuple/array e.g: 1-7 -> [1, 7]
  const [low, high] = groupToProcess.split("-");

  // Push values within range to valid codes array
  for (let i = parseInt(low, 10); i <= parseInt(high, 10); i++) {
    const suffix = low.match(/[a-zA-Z]/);

    let code = i.toString();

    // If there is a substitution suffix
    if (suffix) {
      code = i.toString() + suffix[0].toLowerCase();
    }

    validCodesArray.push(code);
  }
}

export function comparePartNumbers(a, b) {
  const aFirstNum = parseInt(
    parseCollectionNumber(a)[0].replace(/[a-zA-Z]/g, ""),
    10
  );
  const bFirstNum = parseInt(
    parseCollectionNumber(b)[0].replace(/[a-zA-Z]/g, ""),
    10
  );
  return aFirstNum - bFirstNum;
}
